export const MAX_INT32 = 2147483647;
export const MIN_INT32 = -2147483648;

export const MAX_NUMBER = Number.MAX_VALUE;
export const MIN_NUMBER = Number.MIN_VALUE;

export const STRING = 'string';
export const INTEGER = 'integer';
export const NUMBER = 'number';
export const BOOLEAN = 'boolean';
export const COLOR = 'color';
export const URL = 'url';
export const DATETIME = 'datetime';
export const DICT = 'dict';
export const ARRAY = 'array';
